// extracted by mini-css-extract-plugin
export default {"label":"label__x6eSQ","icon":"icon__EoZ1i"};